import { render, staticRenderFns } from "./SupplierRiskModelProfileVerification.vue?vue&type=template&id=1a7ed8be&scoped=true&"
import script from "./SupplierRiskModelProfileVerification.vue?vue&type=script&lang=js&"
export * from "./SupplierRiskModelProfileVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ed8be",
  null
  
)

export default component.exports